import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Button,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  MenuItem,
  Typography,
  Chip,
  Grid
} from '@mui/material';
import api from '../../api/api';
import CloseIcon from '@mui/icons-material/Close';

const ApproveRequestDialogAdmin = ({ open, handleClose, handleApprove, moduleName = "" }) => {
  const [cars, setCars] = useState([]);
  const [available, setAvailable] = useState(true);
  const [selectedCar, setSelectedCar] = useState('');
  const [driverName, setDriverName] = useState('');
  const [driverMobile, setDriverMobile] = useState('');
  const [courierTrackingNumber, setCourierTrackingNumber] = useState('');
  const [courierCompany, setCourierCompany] = useState('');
  const [hyperlinkForTracking, setHyperlinkForTracking] = useState('');
  const [files, setFiles] = useState([]);
  const [remark, setRemark] = useState('');
  const [isIssuedOrNotAvailable, setIssuedOrNotAvailable] = useState('issued');

  useEffect(() => {
    fetchCars();
  }, []);

  const fetchCars = async () => {
    try {
      const response = await api.get('/api/Cars');
      setCars(response.data);
    } catch (error) {
      console.error('Error fetching departments', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case 'carId':
        setSelectedCar(value);
        break;
      case 'driverName':
        setDriverName(value);
        break;
      case 'driverMobile':
        setDriverMobile(value);
        break;
      case 'courierTrackingNumber':
        setCourierTrackingNumber(value);
        break;
      case 'courierCompany':
        setCourierCompany(value);
        break;
      case 'hyperlinkForTracking':
        setHyperlinkForTracking(value);
        break;
      case 'files':
        setFiles(value);
        break;
      case 'remark':
        setRemark(value);
        break;
      case 'isIssuedOrNotAvailable':
        setIssuedOrNotAvailable(value);
        break;
    }
  };

  const handleAvailibilityChange = (event) => {
    const { _, value } = event.target;
    setAvailable(value == "true")
  }

  const handleSubmit = () => {
    if (moduleName == "CourierService")
      handleApprove(courierTrackingNumber, courierCompany, hyperlinkForTracking, files);
    else if (moduleName == "TravelTicket" || moduleName == "HotelBooking")
      handleApprove(remark, files);
    else if (moduleName == "UniformRequirement")
      handleApprove(remark, isIssuedOrNotAvailable);
    else
      handleApprove(available, selectedCar, driverName, driverMobile);

    handleClose(); // Close the dialog after submission
  };

  const getFileIcon = (file) => {
    const extension = file.name.split('.').pop().toLowerCase();
    switch (extension) {
      case 'jpg':
        break;
      case 'jpeg':
        break;
      case 'png':
        break;
    }
  };

  const handleDeleteFile = (fileName) => {
    setFiles((prevFiles) => prevFiles.filter(file => file.name !== fileName));
  };

  const handleFileChange = (event) => {
    const allowedExtensions = ['jpg', 'jpeg', 'png'];
    const newFiles = Array.from(event.target.files).filter((file) => {
      const extension = file.name.split('.').pop().toLowerCase();
      return allowedExtensions.includes(extension);
    });
  
    // Optionally, show an alert or message for unsupported files
    if (newFiles.length !== event.target.files.length) {
      alert("Some files were not added because they are not supported photo formats.");
    }
  
    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
  };

  const handleTravelTicketFileChange = (event) => {
    const allowedExtensions = ['jpg','jpeg','png','doc','docx','pdf'];
    const newFiles = Array.from(event.target.files).filter((file) => {
      const extension = file.name.split('.').pop().toLowerCase();
      return allowedExtensions.includes(extension);
    });
  
    // Optionally, show an alert or message for unsupported files
    if (newFiles.length !== event.target.files.length) {
      alert("Some files were not added because they are not supported photo formats.");
    }
  
    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
  };
  

  return (
    <Dialog open={open} onClose={handleClose}>
      <form onSubmit={handleSubmit}>
        <DialogTitle>Approve Request</DialogTitle>
        {
          moduleName == "" &&
          <DialogContent sx={{ width: '30vw' }}>
            <DialogContentText>
              {
                `Please provide car availability details.`
              }
            </DialogContentText>
            <FormControl margin="dense" component="fieldset">
              <FormLabel component="legend">Is vehicle available?</FormLabel>
              <RadioGroup
                row
                name="isVehicleAvailable"
                value={available}
                onChange={handleAvailibilityChange}
              >
                <FormControlLabel value="true" control={<Radio />} label="Yes" />
                <FormControlLabel value="false" control={<Radio />} label="Hire a cab or use a self-vehicle." />
              </RadioGroup>
            </FormControl>
            {
              available &&
              <TextField
                margin="dense"
                label="Cars"
                name="carId"
                value={selectedCar}
                onChange={handleInputChange}
                inputProps={{ required: available }}
                fullWidth
                select>
                {cars.map((car) => (
                  <MenuItem key={car.id} value={car.id}>
                    {car.name}
                  </MenuItem>
                ))}
              </TextField>
            }
            {
              available &&
              <TextField
                name='driverName'
                margin="dense"
                label="Driver Name"
                type="text"
                fullWidth
                value={driverName}
                inputProps={{ required: available }}
                onChange={handleInputChange}
              />
            }
            {
              available &&
              <TextField
                name='driverMobile'
                margin="dense"
                label="Driver Mobile No."
                type="number"
                onWheel={(e) => e.target.blur()}
                fullWidth
                value={driverMobile}
                inputProps={{ required: available }}
                onChange={handleInputChange}
              />
            }
          </DialogContent>
        }
        {
          moduleName == "CourierService" &&
          <DialogContent sx={{ width: '30vw' }}>
            <DialogContentText>
              {
                `Please provide below details.`
              }
            </DialogContentText>
            <TextField
              name='courierTrackingNumber'
              margin="dense"
              label="Courier Tracking Number"
              type="text"
              fullWidth
              required
              value={courierTrackingNumber}
              onChange={handleInputChange}
            />
            <TextField
              name='courierCompany'
              margin="dense"
              label="Courier Company"
              type="text"
              fullWidth
              required
              value={courierCompany}
              onChange={handleInputChange}
            />
            <TextField
              name='hyperlinkForTracking'
              margin="dense"
              label="Hyperlink for tracking"
              type="text"
              fullWidth
              required
              value={hyperlinkForTracking}
              onChange={handleInputChange}
            />
            <Typography variant="h6" mt={2}>
              Upload Supporting Documents
            </Typography>
            <Grid container spacing={2} sx={{ my: 2 }}>
              {files.map((file, index) => (
                <Grid item key={index}>
                  <Chip
                    icon={getFileIcon(file)}
                    label={file.name}
                    onDelete={() => handleDeleteFile(file.name)}
                    deleteIcon={<CloseIcon />}
                  />
                </Grid>
              ))}
            </Grid>
            <Button variant="text" component="label">
              Add Files
              <input
                type="file"
                accept=".jpg,.jpeg,.png"
                hidden
                multiple
                onChange={handleFileChange}
              />
            </Button>
          </DialogContent>
        }
        {
          (moduleName == "TravelTicket" || moduleName == "HotelBooking") &&
          <DialogContent sx={{width: '30vw'}}>
            <DialogContentText>
              {
                "Please provide a remark for approving the request."
              }
            </DialogContentText>
            <TextField
              autoFocus
              name="remark"
              margin="dense"
              label="Remark *" 
              type="text"
              fullWidth
              value={remark}
              onChange={handleInputChange}
              helperText={ "Remark is required."}
            />
            <Typography variant="h6" mt={2}>
              Upload Documents
            </Typography>
            <Grid container spacing={2} sx={{ my: 2 }}>
              {files.map((file, index) => (
                <Grid item key={index}>
                  <Chip
                    icon={getFileIcon(file)}
                    label={file.name}
                    onDelete={() => handleDeleteFile(file.name)}
                    deleteIcon={<CloseIcon />}
                  />
                </Grid>
              ))}
            </Grid>
            <Button variant="text" component="label">
              Add Files
              <input
                type="file"
                accept=".jpg,.jpeg,.png,.doc,.docx,.pdf"
                hidden
                multiple
                onChange={handleTravelTicketFileChange}
              />
            </Button>
          </DialogContent>
        }
        {
          (moduleName == "UniformRequirement") &&
          <DialogContent sx={{width: '30vw'}}>
            <DialogContentText>
              {
                "Please provide a below details for approving the request."
              }
            </DialogContentText>
            <Grid item xs={12} sm={6} sx={{marginTop: '12px'}}>
              <FormControl component="fieldset">
                <FormLabel component="legend">Issued or Not Available</FormLabel>
                <RadioGroup
                  row
                  name="isIssuedOrNotAvailable"
                  value={isIssuedOrNotAvailable}
                  onChange={handleInputChange}
                  required
                >
                  <FormControlLabel value="issued" control={<Radio />} label="Issued" />
                  <FormControlLabel value="notavailable" control={<Radio />} label="Not Available" />
                </RadioGroup>
              </FormControl>
            </Grid> 
            <TextField
              autoFocus
              name="remark"
              margin="dense"
              label={isIssuedOrNotAvailable === 'issued' ? "Remark (optional)" : "Remark "}
              type="text"
              fullWidth
              value={remark}
              onChange={handleInputChange}
              helperText={isIssuedOrNotAvailable === 'notavailable' ? "Remark is required." : ""}
              required={isIssuedOrNotAvailable === 'notavailable'}
              error={isIssuedOrNotAvailable === 'notavailable'}
            />
          </DialogContent>
        }

        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button type='submit' color="primary">
            Approve
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ApproveRequestDialogAdmin;
